import React from 'react'
import { HeroSection } from '@/components/ui/hero-section'
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Zap, Image, Clock, Lock } from "lucide-react";
import Footer from "@/components/Footer";
import { Gallery4Demo } from "@/components/ui/gallery4-demo";
import { IconCloudDemo } from "@/components/ui/interactive-icon-cloud";
import { motion } from "framer-motion";

const Index = () => {
  const features = [
    {
      icon: <Sparkles className="h-6 w-6 text-primary" />,
      title: "High Quality Images",
      description: "Generate beautiful, high-resolution images with our state-of-the-art AI models.",
    },
    {
      icon: <Zap className="h-6 w-6 text-primary" />,
      title: "Lightning Fast",
      description: "Get your images in seconds with our optimized generation pipeline.",
    },
    {
      icon: <Image className="h-6 w-6 text-primary" />,
      title: "Unlimited Styles",
      description: "Create images in any style or aesthetic you can imagine.",
    },
    {
      icon: <Clock className="h-6 w-6 text-primary" />,
      title: "24/7 Generation",
      description: "Create images whenever inspiration strikes, day or night.",
    },
    {
      icon: <Lock className="h-6 w-6 text-primary" />,
      title: "Private & Secure",
      description: "Your prompts and images are kept private and secure.",
    },
  ];

  const pricingPlans = [
    {
      name: "Free",
      price: "$0",
      description: "Perfect for trying out our platform",
      features: ["5 images per day", "Standard quality", "Basic styles"],
      cta: "Get Started",
      popular: false,
    },
    {
      name: "Pro",
      price: "$15",
      period: "/month",
      description: "For creators who need more power",
      features: ["100 images per day", "High quality", "All styles", "Priority generation"],
      cta: "Subscribe Now",
      popular: true,
    },
    {
      name: "Enterprise",
      price: "$49",
      period: "/month",
      description: "For teams and businesses",
      features: ["Unlimited images", "Highest quality", "All styles", "Priority generation", "API Access"],
      cta: "Contact Sales",
      popular: false,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
    </div>
  );
};

export default Index;
